import type {Result, UseCase} from 'framework';
import type {ProductId} from '../../domain/product';
import type {ProductError} from '../../domain/errors';
import type {ProductRepository} from '../ports/product.repository';

export type DeleteProductInput = {
  readonly productId: ProductId;
};

export class DeleteProduct implements UseCase<[DeleteProductInput], void> {
  constructor(private readonly repository: ProductRepository) {}

  execute(input: DeleteProductInput): Promise<Result<void, ProductError>> {
    return this.repository.delete(input.productId);
  }
}
